import { module } from 'modujs';

const CLASS = {
    ACTIVE: 'is-active'
}

export default class Categories extends module {

    static get settings() {
        return {
            CLASS_ACTIVE: 'is-current',
        }
    }

    constructor(m) {
        super(m);

        this.events = {
            click: {
                link: 'handleClick'
            }
        }

        this.transition = this.getData('transition') || null;
    }

    init() {
    }

    handleClick(e) {
        e.stopPropagation()
        e.preventDefault()
        console.log('handleClick', e)

        const el = e.curTarget;
        const url = el.href;
        const transition = this.transition;

        this.setActive(el);

        this.call('goTo', { url, transition }, 'Load');
    }

    setActive(el) {
        this.$('link').forEach(element => {
            if(el === element) {
                element.classList.add(Categories.settings.CLASS_ACTIVE)
            } else {
                element.classList.remove(Categories.settings.CLASS_ACTIVE)
            }
        })
    }
}
